<hr>
<h2>September 27th</h2>
<table class="orari" cellspacing="2" cellpadding="2" id="27morning">
    <tr bgcolor="lightblue">
        <th class="schedule" colspan="2">
            <font size="+1">
                <b>September 27th (morning) - Workshop Session</b>
                <br>
                <i class="location">Centro D. Menichella, Largo Guido Carli 1, Frascati (Rome)</i>
            </font>
        </th>
    </tr>
    <tr id="fcir24-i">
        <td colspan="2">
            <h2>MAIN HALL</h2>
        </td>
    </tr>
    <tr>
        <td class="schedule"> 10:00<br>11:20 </td>
        <!------------------------------>
        <!-- WORKSHOP DCC E BDI        -->
        <!------------------------------>
        <td>
            <em><b style="color:var(--cifris_blue)"> FCiR - Financial Cryptography in Rome 2024, session I</b></em>
            <!-- VERSIONE NORMALE -->
            <p>
                Joint workshop of Banca d'Italia and De Cifris on novel financial applications of cryptography.
            </p>
            <p>
                Invited speakers:
                <b>Carsten Maple</b>, University of Warwick (UK), and
                <b>Christian Rechberger</b>, Graz University of Technology (Austria)
            </p>
            <!-- VERSIONE ESTESA -->
            <p *ngIf="showMoreFCR1">
                Organisers:
                <i>
                    Michela Iezzi (Banca d'Italia) and Massimiliano Sala (De Cifris).
                </i>
            </p>
            <p *ngIf="showMoreFCR1">
                Financial Cryptography in Rome (FCiR) and Data Security covers all aspects of securing
                transactions and digital value, with a specific focus on commercial and currency contexts. While we
                hosts cryptographic talks on both fundamental research and real-world applications, we encourage also
                interdisciplinary works not strictly related to cryptography.
            </p>
            <ul *ngIf="showMoreFCR1">
                <li>
                    <i><b>Carsten Maple</b>, University of Warwick (UK)</i>
                    <br>
                    Keynote: Secure and Private Data Sharing in Financial Institutions
                </li>
                <li>
                    <i><b>Christian Rechberger</b>, Graz University of Technology (Austria)</i>
                    <br>
                    Keynote: Progress on Private Computation
                </li>
            </ul>
            <button mat-button (click)="toggleShowMoreFCR1()" class="btn-showmore">
                {{ showMoreFCR1 ? 'Show Less' : 'Show More' }}
            </button>
            <a mat-button href="/cifris24/fcir24" class="btn-showmore" style="margin-left: 10px;">
                Show all details
            </a>
        </td>
    </tr>
    <tr id="fcir24-ii">
        <td class="schedule"> 11:20<br>11:40 </td>
        <td><em> Coffee break </em></td>
    </tr>
    <tr>
        <td class="schedule"> 11:40<br>13:00 </td>
        <!------------------------------>
        <!-- WORKSHOP DCC E BDI        -->
        <!------------------------------>
        <td>
            <em><b style="color:var(--cifris_blue)"> FCiR - Financial Cryptography in Rome 2024, session II</b></em>
            <!-- VERSIONE NORMALE -->
            <p>
                Joint workshop of Banca d'Italia and De Cifris on novel financial applications of cryptography.
            </p>
            <!-- VERSIONE ESTESA -->
            <p *ngIf="showMoreFCR2">
                Organisers:
                <i>
                    Michela Iezzi (Banca d'Italia) and Massimiliano Sala (De Cifris).
                </i>
            </p>
            <p *ngIf="showMoreFCR2">
                Financial Cryptography in Rome (FCiR) and Data Security covers all aspects of securing
                transactions and digital value, with a specific focus on commercial and currency contexts. While we
                hosts cryptographic talks on both fundamental research and real-world applications, we encourage also
                interdisciplinary works not strictly related to cryptography.
            </p>
            <ul *ngIf="showMoreFCR2">
                <li>
                    <i><b>Giuseppe Galano</b>, Bank of Italy (Italy)</i>
                    <br>
                    Layer-2 Innovations for Scalable Blockchain Payments
                </li>
                <li>
                    <i><b>Amit Chaudhary</b>, Labyrinth Technology (UK)</i>
                    <br>
                    Decentralized Finance: Labyrinth
                </li>
                <li>
                    <i><b>Costanza Catalano</b> and <b>Andrea Coletta</b>, Bank of Italy (Italy)</i>
                    <br>
                    Confidential Knowledge Graphs through Synthetic Augmentation
                </li>
                <li>
                    <b>Final discussion and round table</b>
                </li>
            </ul>
            <button mat-button (click)="toggleShowMoreFCR2()" class="btn-showmore">
                {{ showMoreFCR2 ? 'Show Less' : 'Show More' }}
            </button>
            <a mat-button href="/cifris24/fcir24" class="btn-showmore" style="margin-left: 10px;">
                Show all details
            </a>
        </td>
    </tr>
    <tr>
        <td class="schedule">13:00<br>14:00</td>
        <td><em> Lunch </em></td>
    </tr>
    <tr>
        <td colspan="2" id="tac24-i">
            <h2>ROOM A</h2>
        </td>
    </tr>
    <tr>
        <td class="schedule"> 10:00<br>11:20 </td>
        <!------------------------------>
        <!-- WORKSHOP TAC        -->
        <!------------------------------>
        <td>
            <em><b style="color:var(--cifris_blue)"> TAC - Topics in Applied Cryptography 2024, session I</b></em>
            <!-- VERSIONE NORMALE -->
            <p>
                Specific applications, scenarios and technologies: performance, hardware, IoT, attacks, vulnerabilities,
                unusual applications, etc.
            </p>
            <p>
                Invited speaker:
                <b>Filippo Valsorda</b>, full-time independent open source maintainer (USA).
            </p>
            <!-- VERSIONE ESTESA -->
            <p *ngIf="showMoreTAC1">
                Organisers:
                <em>
                    Riccardo Longo (Fondazione Bruno Kessler, Italy),
                    Alessandro Tomasi (Fondazione Bruno Kessler, Italy),
                    Chiara Spadafora (University of Trento, Italy),
                    Silvio Ranise (University of Trento and Fondazione Bruno Kessler, Italy),
                    Stefano Berlato (Fondazione Bruno Kessler, Italy)
                </em>
            </p>
            <p *ngIf="showMoreTAC1">
                Topics in Applied Cryptography 2024 (TAC2024) is a workshop dedicated to cryptography
                with a specific application,
                scenario and/or technology in mind, including performance evaluation, libraries and implementation
                issues, hardware
                and IoT, attacks and vulnerabilities, and requirements for unusual application scenarios; purely
                theoretical results
                are out of scope. Topics of interest include privacy enhancing cryptography, homomorphic encryption,
                secure
                multi-party computation, quantum key distribution, and quantum-safe cryptography.
            </p>
            <ul *ngIf="showMoreTAC1">
                <li>
                    <i><b>Filippo Valsorda</b>, independent open source maintainer (Italy)</i>
                    <br>
                    Keynote - Transparency, trust and accountability
                </li>
                <li>
                    <i><b>Noel Elias</b>, University of Texas (USA)</i>
                    <br>
                    Remote presentation - Lova: A Novel Framework for Verifying Mathematical Proofs with
                    Incrementally
                    Verifiable Computation
                </li>
                <li>
                    <i><b>Amit Chaudhary</b>, University of Warwick (UK)</i>
                    <br>
                    Work-in-progress - HASHTA AI: Share and compute securely your data
                </li>
                <li>
                    <i><b>Sara Montanari</b>, University of Trento and FBK (Italy)</i>
                    <br>
                    Work-in-progress - Extensible Decentralized Verifiable Refreshable Secret Sharing Protocol with
                    Extension to Threshold Access Trees for Wallet Key Recovery
                </li>
            </ul>
            <button mat-button (click)="toggleShowMoreTAC1()" class="btn-showmore">
                {{ showMoreTAC1 ? 'Show Less' : 'Show More' }}
            </button>
            <a mat-button href="/cifris24/tac24" class="btn-showmore" style="margin-left: 10px;">
                Show all details
            </a>
            <a mat-button href="https://aleph.fbk.eu/events/TAC2024/index.html" class="btn-showmore"
                style="margin-left: 10px;">
                Website
            </a>
        </td>
    </tr>
    <tr id="tac24-ii">
        <td class="schedule"> 11:20<br>11:40 </td>
        <td><em> Coffee break </em></td>
    </tr>
    <tr>
        <td class="schedule"> 11:40<br>13:00 </td>
        <!------------------------------>
        <!-- WORKSHOP TAC        -->
        <!------------------------------>
        <td>
            <em><b style="color:var(--cifris_blue)"> TAC - Topics in Applied Cryptography 2024, session II</b></em>
            <!-- VERSIONE NORMALE -->
            <p>
                Specific applications, scenarios and technologies: performance, hardware, IoT, attacks, vulnerabilities,
                unusual applications, etc.
            </p>
            <!-- VERSIONE ESTESA -->
            <p *ngIf="showMoreTAC2">
                Organisers:
                <em>
                    Riccardo Longo (Fondazione Bruno Kessler, Italy),
                    Alessandro Tomasi (Fondazione Bruno Kessler, Italy),
                    Chiara Spadafora (University of Trento, Italy),
                    Silvio Ranise (University of Trento and Fondazione Bruno Kessler, Italy),
                    Stefano Berlato (Fondazione Bruno Kessler, Italy)
                </em>
            </p>
            <p *ngIf="showMoreTAC2">
                Topics in Applied Cryptography 2024 (TAC2024) is a workshop dedicated to cryptography
                with a specific application,
                scenario and/or technology in mind, including performance evaluation, libraries and implementation
                issues, hardware
                and IoT, attacks and vulnerabilities, and requirements for unusual application scenarios; purely
                theoretical results
                are out of scope. Topics of interest include privacy enhancing cryptography, homomorphic encryption,
                secure
                multi-party computation, quantum key distribution, and quantum-safe cryptography.
            </p>
            <ul *ngIf="showMoreTAC2">
                <li>
                    <i><b>Stefano Berlato</b>, FBK (Italy)</i>
                    <br>
                    Lightning talk - Improving Security and Performance of Cryptographic Access Control with Trusted
                    Execution Environments
                </li>
                <li>
                    <i><b>Enrico Sorbera</b>, FBK (Italy)</i>
                    <br>
                    Work-in-progress - On the combination of Searchable Encryption and Attribute-based encryption
                </li>
                <li>
                    <b>Round table</b>, discussion and community feedback on hot topics, involving as much as
                    possible the whole audience
                </li>
            </ul>
            <button mat-button (click)="toggleShowMoreTAC2()" class="btn-showmore">
                {{ showMoreTAC2 ? 'Show Less' : 'Show More' }}
            </button>
            <a mat-button href="/cifris24/tac24" class="btn-showmore" style="margin-left: 10px;">
                Show all details
            </a>
            <a mat-button href="https://aleph.fbk.eu/events/TAC2024/index.html" class="btn-showmore"
                style="margin-left: 10px;">
                Website
            </a>
        </td>
    </tr>
    <tr>
        <td class="schedule">13:00<br>14:00</td>
        <td><em> Lunch </em></td>
    </tr>
    <tr id="ntc24">
        <td colspan="2">
            <h2>ROOM B</h2>
        </td>
    </tr>
    <tr>
        <td class="schedule"> 10:00<br>11:20 </td>
        <!------------------------------>
        <!-- WORKSHOP NUMBER THEORY   -->
        <!------------------------------>
        <td>
            <em><b style="color:var(--cifris_blue)"> NTC - Number Theory for Cryptography 2024</b></em>
            <!-- VERSIONE NORMALE -->
            <p>
                Exploring the connections between number theory and cryptography, with a focus on the most
                challenging topics.
            </p>
            <p>
                Invited speaker:
                <b>Federico Pintore</b>, University of Trento (Italy)
            </p>
            <!-- VERSIONE ESTESA -->
            <p *ngIf="showMoreNTC">
                Organisers:
                <i>
                    Federico Accossato (PoliTo), Gessica Alecci (PoliTo), Danilo Bazzanella (PoliTo), Laura Capuano
                    (RomaTre), Giuseppe D’Alconzo (PoliTo), Simone Dutto (ACN), Nadir Murru (UniTN), Giordano Santilli
                    (ACN).
                </i>
            </p>
            <p *ngIf="showMoreNTC">
                The workshop aims at exploring the connections between number theory and
                cryptography with a focus on the most challenging topics involved in modern cryptography (from classical
                public-key algorithms to post-quantum cryptography). Particular emphasis will be given to the
                applications of number theory for developing new cryptosystems and methods of cryptanalysis.
            </p>
            <ul *ngIf="showMoreNTC">
                <li>
                    <i><b>Federico Pintore</b>, University of Trento (Italy)</i>
                    <br>
                    Hessians of elliptic curves: isogenies and graphs
                </li>
                <li>
                    <i><b>Marzio Mula</b>, Universität des Bundeswehr München (Germany)</i>
                    <br>
                    Proving knowledge of an isogeny using modular polynomials
                </li>
                <li>
                    <i><b>Stefano Barbero</b>, Politecnico di Torino (Italy)</i>
                    <br>
                    Lattices and Cryptography, an Overview
                </li>
                <li>
                    <i><b>Guglielmo Morgari</b>, Telsy SPA (Italy)</i>
                    <br>
                    A Note on the P-values Distribution in NIST SP 800-22 Rev. 1a Statistical Tests
                </li>
            </ul>
            <button mat-button (click)="toggleShowMoreNTC()" class="btn-showmore">
                {{ showMoreNTC ? 'Show Less' : 'Show More' }}
            </button>
            <a mat-button href="/cifris24/ntc24" class="btn-showmore" style="margin-left: 10px;">
                Show all details
            </a>
        </td>
    </tr>
    <tr id="qcifris24">
        <td class="schedule"> 11:20<br>11:40 </td>
        <td><em> Coffee break </em></td>
    </tr><tr>
        <td class="schedule"> 11:40<br>13:00 </td>
        <!------------------------------>
        <!-- WORKSHOP FISICI   -->
        <!------------------------------>
        <td>
            <em><b style="color:var(--cifris_blue)"> QCifris - Quantum Cifris 2024</b></em>
            <!-- VERSIONE NORMALE -->
            <p>
                Advances in quantum technologies and applications in cryptography from the perspective of Physics.
            </p>
            <!-- VERSIONE ESTESA -->
            <p *ngIf="showMoreQCIFRIS">
                Organisers:
                <i>
                    Paolo Villoresi (Università di Padova) <br>
                    Marco Genovese (INRIM-Torino) <br>
                    Fabio Sciarrino (Università di Roma La Sapienza) <br>
                    Cristian Antonelli (Università dell’Aquila) <br>
                    Giuseppe Vallone (Università di Padova)
                </i>
            </p>
            <p *ngIf="showMoreQCIFRIS">
                Countering the growing level of cybercrime requires an ever-innovative approach. Quantum
                Technologies propose solutions for cryptographic key exchange and random number generation
                that are radically new compared to the algorithmic approach, with which they can be integrated to
                achieve the highest levels of security.
                The state of the art and perspectives in this area will be presented. The status of quantum
                computing in cryptanalysis will also be presented.
            </p>
            <ul *ngIf="showMoreQCIFRIS">
                <li>
                    <i><b>Paolo Villoresi</b>, University of Padova (Italy)</i>
                    <br>
                    Quantum communication protocols and quantum computing
                </li>
                <li>
                    <i><b>Fabio Sciarrino</b>, University of Roma La Sapienza (Italy)</i>
                    <br>
                    Entanglement for quantum key distribution
                </li>
                <li>
                    <i><b>Simone Montangero</b>, University of Padova (Italy)</i>
                    <br>
                    Quantum Computing in Cybersecurity
                </li>
                <li>
                    <i><b>Giuseppe Vallone</b>, University of Padova (Italy)</i>
                    <br>
                    Genuine random numbers from quantum processes for cybersecurity
                </li>
                <li>
                    <i><b>Tommaso Occhipinti</b>, QTI (Italy)</i>, and
                    <i><b>Simone Capeleto</b>, ThinkQuantum SRL (Italy)</i>
                    <br>
                    National and European Quantum Communications for Enhanced Security: Technology and
                    Applications
                </li>
            </ul>
            <button mat-button (click)="toggleShowMoreQCIFRIS()" class="btn-showmore">
                {{ showMoreQCIFRIS ? 'Show Less' : 'Show More' }}
            </button>
            <a mat-button href="/cifris24/qcifris24" class="btn-showmore" style="margin-left: 10px;">
                Show all details
            </a>
        </td>
    </tr>
    <tr>
        <td class="schedule">13:00<br>14:00</td>
        <td><em> Lunch </em></td>
    </tr>
    <tr>
        <td colspan="2" id="symcrypt24">
            <h2>ROOM C</h2>
        </td>
    </tr>
    <tr>
        <td class="schedule"> 10:00<br>11:20 </td>
        <!------------------------------>
        <!-- WORKSHOP SYMMETRIC       -->
        <!------------------------------>
        <td>
            <em><b style="color:var(--cifris_blue)"> SymCrypt - Symmetric Cryptography and Boolean Functions
                    2024</b></em>
            <!-- VERSIONE NORMALE -->
            <p>
                Topics in symmetric cryptography with a focus on properties, classification, and construction of Boolean
                Functions.
            </p>
            <p>
                Invited speaker:
                <b>Sihem Mesnager</b>, University of Paris VIII (France)
            </p>
            <!-- VERSIONE ESTESA -->
            <p *ngIf="showMoreSYMCRYPT">
                Organisers:
                <i>
                    Marco Calderini (University of Trento - Italy),
                    George Petrides (University of Cyprus - Cyprus),
                    Irene Villa (University of Genoa & University of Trento – Italy).
                </i>
            </p>
            <p *ngIf="showMoreSYMCRYPT">
                The workshop will be in two interrelated areas. The first one concerns different
                aspects of symmetric cryptography, such as the design of symmetric ciphers, attacks to these ciphers, as
                well as countermeasures. The second topic of interest is the theory of Boolean functions applied in
                cryptography scenarios, particularly in the design of symmetric ciphers. Such functions have found
                applications as S-boxes of block ciphers and feedback functions in stream ciphers, and the workshop will
                be focusing on their relevant cryptographic properties, their classification, and construction methods.
            </p>
            <ul *ngIf="showMoreSYMCRYPT">
                <li>
                    <i><b>Roberto La Scala</b>, University of Bari (Italy)</i>
                    <br>
                    Stream ciphers encoded by difference equations over finite fields and their cryptanalysis
                </li>
                <li>
                    <i><b>Luca Mariot</b>, University of Twente (Netherlands)</i>
                    <br>
                    On the computation of the Walsh-Hadamard Transform using Binomial Trees
                </li>
                <li>
                    <i><b>Sihem Mesnager</b>, University of Paris VIII (France)</i>
                    <br>
                    (Cryptographic) Functions for Designing Locally Recoverable Codes in Distributed Storage
                </li>
            </ul>
            <button mat-button (click)="toggleShowMoreSYMCRYPT()" class="btn-showmore">
                {{ showMoreSYMCRYPT ? 'Show Less' : 'Show More' }}
            </button>
            <a mat-button href="/cifris24/symcrypt24" class="btn-showmore" style="margin-left: 10px;">
                Show all details
            </a>
        </td>
    </tr>
    <tr id="codemath24">
        <td class="schedule"> 11:20<br>11:40 </td>
        <td><em> Coffee break </em></td>
    </tr>
    <tr>
        <td class="schedule"> 11:40<br>13:00 </td>
        <!------------------------------>
        <!-- WORKSHOP CODES MATH   -->
        <!------------------------------>
        <td>
            <em><b style="color:var(--cifris_blue)"> CodeMath - Coding Theory and Discrete Mathematics 2024</b></em>
            <!-- VERSIONE NORMALE -->
            <p>
                Networking and discussion event on: Algebraic Foundations and Advanced Topics of Coding theory,
                relations with Cryptography and Finite Geometry, trends, challenges.
            </p>
            <p>
                Invited speaker: <b>Gilles Zémor</b>,
                Institut de Mathématiques de Bordeaux (France)
            </p>
            <!-- VERSIONE ESTESA -->
            <p *ngIf="showMoreCODEMATH">
                Organisers:
                <i>
                    Massimo Giulietti (Università di Perugia),
                    Giuseppe Marino (Università di Napoli Federico II),
                    Olga Polverino (Università della Campania “Luigi Vanvitelli”),
                    Ferdinando Zullo (Università della Campania “Luigi Vanvitelli”)
                </i>
            </p>
            <p *ngIf="showMoreCODEMATH">
                The aim of the workshop is to create a collaborative environment that promotes research
                and innovation in these fields, to facilitate networking opportunities for participants to engage with
                peers, industry experts, and researchers, and to showcase the practical applications of coding theory
                and discrete mathematics in areas such as error correction and cryptography.
                Subjects of interest for the Workshop will be: Algebraic Foundations of Coding theory (Finite fields,
                Polynomial algebras, Algebraic Varieties and their applications in coding), Advanced Topics in Coding
                Theory (such as turbo codes and LDPC codes; network coding and its applications; quantum error
                correction), Cryptography and its relation to Coding theory and Finite Geometry, Current trends and
                challenges in coding theory and discrete mathematics.
            </p>
            <ul *ngIf="showMoreCODEMATH">
                <li>
                    <i><b>Gilles Zémor</b>, Institut de Mathématiques de Bordeaux (France)</i>
                    <br>
                    Hadamard products of codes: an Additive Combinatorics perspective
                </li>
                <li>
                    <i><b>Daniele Bartoli</b>, Università degli Studi di Perugia (Italy)</i>
                    <br>
                    Recent results on scattered spaces and MRD codes
                </li>
                <li>
                    <i><b>Luca Giuzzi</b>, Università degli Studi di Brescia (Italy)</i>
                    <br>
                    Cryptographic uses of (polar) Grassmannians
                </li>
                <li>
                    <i><b>Violetta Weger</b>, Technical University of Munich (Germany)</i>
                    <br>
                    CROSS: a signature scheme with restricted errors
                </li>
            </ul>
            <button mat-button (click)="toggleShowMoreCODEMATH()" class="btn-showmore">
                {{ showMoreCODEMATH ? 'Show Less' : 'Show More' }}
            </button>
            <a mat-button href="/cifris24/codemath24" class="btn-showmore" style="margin-left: 10px;">
                Show all details
            </a>
        </td>
    </tr>
    <tr>
        <td class="schedule">13:00<br>14:00</td>
        <td><em> Lunch </em></td>
    </tr>
    <tr id="cpsid24">
        <td colspan="2">
            <h2>ROOM D</h2>
        </td>
    </tr>
    <tr>
        <td class="schedule"> 10:00<br>11:20 </td>
        <!------------------------------>
        <!-- WORKSHOP IDENTITY        -->
        <!------------------------------>
        <td>
            <em><b style="color:var(--cifris_blue)"> CPSID - Cryptography, Protocols and Security in Digital Identity
                    2024</b></em>
            <!-- VERSIONE NORMALE -->
            <p>
                We will explore the two main standards, EUDI-ARF and W3C-DID/W3C-VC, their cryptography, protocols,
                threat models and mitigations, but also emerging cryptographic schemes.
            </p>
            <!-- VERSIONE ESTESA -->
            <p *ngIf="showMoreCPSID">
                Organisers:
                <i>
                    Andrea D'Intino (Dyne Foundation), Denis "Jaromil" Roio (Dyne Foundation)
                </i>
            </p>
            <p *ngIf="showMoreCPSID">
                The seminar dives into the two main current identity standards, EUDI-ARF and
                W3C-DID/W3C-VC and describe their cryptography, protocols, threat models and mitigations,
                highlighting pros and cons of each element. The seminar also offers a view about new and emerging
                cryptographic schemes in the identity space.
            </p>
            <ul *ngIf="showMoreCPSID">
                <li>
                    <i><b>Andrea D'Intino</b>, Dyne Foundation (Netherlands)</i>
                    <br>
                    Overview of the current digital identity standards
                </li>
                <li>
                    <i><b>Francesco Marino</b>, Poligrafico e Zecca dello Stato (Italy)</i>
                    <br>
                    Current status of the implementation of the Italian Wallet and Trust Framework Infrastructure
                </li>
                <li>
                    <i><b>Simone Onofri</b>, W3.org (USA)</i>, and
                    <i><b>Denis Roio</b>, Dyne Foundation (Netherlands)</i>
                    <br>
                    Challenges and upcoming standards
                </li>
            </ul>
            <button mat-button (click)="toggleShowMoreCPSID()" class="btn-showmore">
                {{ showMoreCPSID ? 'Show Less' : 'Show More' }}
            </button>
            <a mat-button href="/cifris24/cpsid24" class="btn-showmore" style="margin-left: 10px;">
                Show all details
            </a>
        </td>
    </tr>
    <tr id="cifriscloud24">
        <td class="schedule"> 11:20<br>11:40 </td>
        <td><em> Coffee break </em></td>
    </tr>
    <tr>
        <td class="schedule"> 11:40<br>13:00 </td>
        <!------------------------------>
        <!-- WORKSHOP FISICI   -->
        <!------------------------------>
        <td>
            <em><b style="color:var(--cifris_blue)"> CifrisCloud - Cryptography for the Cloud 2024</b></em>
            <!-- VERSIONE NORMALE -->
            <p>
                Explore the latest advancements in privacy enhancing techniques specifically designed for cloud
                computing.
            </p>
            <p>
                Invited speaker: <b>Martina Palmucci</b>, NTT Data (Italy)
            </p>
            <!-- VERSIONE ESTESA -->
            <p *ngIf="showMoreCIFRISCLOUD">
                Organisers:
                <i>
                    Michela Iezzi (Bank of Italy), Matteo Nardelli (Bank of Italy) and Marco Pedicini (Roma Tre
                    University)
                </i>
            </p>
            <p *ngIf="showMoreCIFRISCLOUD">
                The widespread use of wearable devices, IoT, smartphones, and sensors is driving the
                need to decentralize cloud computing to the network's edges. This new computing environment involves
                various devices exchanging data at unprecedented speeds, creating a pressing need for cryptographic data
                protection against interception and tampering.
                Key topics in cloud cryptography include data privacy and secure data sharing, as well as advanced
                cryptographic techniques such as homomorphic encryption, attribute-based encryption, functional
                encryption and federated learning.
            </p>
            <ul *ngIf="showMoreCIFRISCLOUD">
                <li>
                    <i><b>Martina Palmucci</b>, NTT Data (Italy)</i>
                    <br>
                    ANTI-fraud: ABE Solutions
                </li>
                <li>
                    <i><b>Roberto La Scala</b>, University of Bari (Italy)</i>
                    <br>
                    An introduction to Functional Encryption with multivariate algebra
                </li>
                <li>
                    <b>Daniele Friolo</b>, University of Roma La Sapienza (Italy)
                    <br>
                    Registered Functional Encryption
                </li>
            </ul>
            <button mat-button (click)="toggleShowMoreCIFRISCLOUD()" class="btn-showmore">
                {{ showMoreCIFRISCLOUD ? 'Show Less' : 'Show More' }}
            </button>
            <a mat-button href="/cifris24/cifriscloud24" class="btn-showmore" style="margin-left: 10px;">
                Show all details
            </a>
        </td>
    </tr>
    <tr>
        <td class="schedule">13:00<br>14:00</td>
        <td><em> Lunch </em></td>
    </tr>
</table>



<table class="orari" cellspacing="2" cellpadding="2" id="27afternoon">
    <tr bgcolor="lightblue">
        <th class="schedule" colspan="2">
            <font size="+1"><b>September 27th (afternoon) - Workshop Session</b></font>
        </th>
    </tr>
    <tr id="readpqc24">
        <td colspan="2">
            <h2>MAIN HALL</h2>
        </td>
    </tr>
    <tr>
        <td class="schedule"> 14:00<br>16:30 </td>
        <!------------------------------>
        <!-- WORKSHOP PQ   -->
        <!------------------------------>
        <td>
            <em><b style="color:var(--cifris_blue)"> ReAdPQC24 - Recent Advances in Post-Quantum Cryptography
                    2024</b></em>
            <!-- VERSIONE NORMALE -->
            <p>
                An overview of the state of the art in PQ cryptography, the NIST competition, and cutting-edge methods
                for design and implementation of post-quantum signatures.
            </p>
            <p>
                Invited speaker:
                <b>Thibauld Feneuil</b>, CryptoExperts (France)
            </p>
            <!-- VERSIONE ESTESA -->
            <p *ngIf="showMoreRAPQC">
                Organisers:
                <i>
                    Giulio Codogni (Tor Vergata University of Rome), Roberto La Scala (University of Bari), Edoardo
                    Persichetti (Florida Atlantic University), Federico Pintore (University of Trento).
                </i>
            </p>
            <p *ngIf="showMoreRAPQC">
                Post-quantum cryptography, that is, the study of cryptographic schemes capable of
                withstanding attackers equipped with both classical and quantum computers, is an area of research that
                has experienced tremendous growth in recent years, also due to the initiation of a standardization
                effort by NIST, which has led to the selection of the first schemes to standardise. More recently, the
                focus has been on post-quantum digital signature schemes, which are the subject of the latest NIST
                competition. This workshop will provide an overview of the state of the art in post-quantum
                cryptography, along with the NIST competition, and focus on cutting-edge methods for designing and
                implementing post-quantum signatures.
            </p>

            <ul *ngIf="showMoreRAPQC">
                <li>
                    <i><b>Thibauld Feneuil</b>, CryptoExperts (France)</i>
                    <br>
                    Post-Quantum Signatures from Secure Multiparty Computation
                </li>
                <li>
                    <i><b>Rocco Mora</b>, CISPA Helmholtz Center for Information Security (Germany)</i>
                    <br>
                    The Regular Multivariate Quadratic problem
                </li>
                <li>
                    <i><b>Ryann Cartor</b>, Clemson University (USA)</i>
                    <br>
                    MinRank Attacks in Multivariate Cryptography
                </li>
                <li>
                    <i><b>Luciano Maino</b>, University of Bristol (UK)</i>
                    <br>
                    Attack-based encryption using isogenies
                </li>
                <li>
                    <i><b>Andrea Basso</b>, IBM Zurich (Switzerland)</i>
                    <br>
                    SQIsign2D-West: The Fast, the Small, and the Safer
                </li>
            </ul>
            <button mat-button (click)="toggleShowMoreRAPQC()" class="btn-showmore">
                {{ showMoreRAPQC ? 'Show Less' : 'Show More' }}
            </button>
            <a mat-button href="/cifris24/readpqc24" class="btn-showmore" style="margin-left: 10px;">
                Show all details
            </a>
        </td>
    </tr>
</table>